import { render, staticRenderFns } from "./StaffDebug.vue?vue&type=template&id=4524398a&scoped=true"
import script from "./StaffDebug.vue?vue&type=script&lang=js"
export * from "./StaffDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524398a",
  null
  
)

export default component.exports